const DEFAULT_DEV_API_BASE_URL = "http://localhost:8000";
const DEFAULT_PRODUCTION_API_BASE_URL = "/api";

export function getApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (configuredUrl) {
    return configuredUrl.replace(/\/+$/, "");
  }

  if (process.env.NODE_ENV === "production") {
    return DEFAULT_PRODUCTION_API_BASE_URL;
  }

  return DEFAULT_DEV_API_BASE_URL;
}

export const API_BASE_URL = getApiBaseUrl();

export function apiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
